<!-- <app-page-loader *ngIf="pageLoader.loading$ | async"></app-page-loader> -->

<router-outlet></router-outlet>